import React from 'react';
import './ourEvents.css'
import {Container, Col, Row, Image} from 'react-bootstrap'
import CustomButton from "../accesories/customBtn/CustomButton";
import {useNavigate} from "react-router-dom";



function OurEvents({events=[]}) {
    const navigate = useNavigate()
    return (
        <Container className={'our-events-container'}>
            <Row className={'our-events-up-row text-center'}>
                <Col>
                    <h3><span>رویدادهای</span> داپا</h3>
                    <div className={'horizontal-line'}/>
                </Col>
            </Row>
            {
                events.length >= 3 &&
                <Row className={'our-events-down-row'}>
                    <Col sm={12} md={12} lg={6} className={'mt-5'} >
                        {/*<Image src={'/images/about-us.jpg'}/>*/}
                        <div className={'our-events-right-col'} style={{background: `url(${events[0].cover})`}}>
                            <Row className={'content'}>
                                <Col sm={12} md={8} lg={9}>
                                    <p className={'date'}>{events[0].event_date}</p>
                                    <p className="title">{events[0].title}</p>
                                    <p className={'description'}>{events[0].summary}</p>
                                </Col>
                                <Col sm={12} md={4} lg={3} className={'button-div'}>
                                    {
                                        console.log('status injas',events[0].status)
                                    }
                                    <CustomButton text={'بیشتر بخوانید'} buttonClicked={()=>{navigate(`/${events[0].status ? 'finished_event': 'event'}/${events[0].id}`)}} height={'3rem'} bgColor={'#EEE'}
                                                  color={'#1D2E3D'}/>
                                </Col>
                            </Row>
                        </div>

                    </Col>
                    <Col sm={12} md={6} lg={3}  className={'mt-5 our-events-middle-col'}>
                        <div className={'left-part-cards'}>
                            <p className={'date'}>{events[1].event_date}</p>
                            <h4 className={'title'}>{events[1].title}</h4>
                            <p className={'description'}>{events[1].summary}</p>
                            <CustomButton text={'مشاهده بیشتر ...'} buttonClicked={()=>{navigate(`/${events[0].status ? 'finished_event': 'event'}/${events[1].id}`)}} color={'#fff'} bgColor={'#1D2E3D'} height={'3rem'} width={'9rem'}/>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={3}  className={'mt-5 our-events-left-col'}>
                        <div className={'left-part-cards'}>
                            <p className={'date'}>{events[2].event_date}</p>
                            <h4 className={'title'}>{events[2].title}</h4>
                            <p className={'description'}>{events[2].summary}</p>
                            <CustomButton text={'مشاهده بیشتر ...'} buttonClicked={()=>{navigate(`/${events[0].status ? 'finished_event': 'event'}/${events[2].id}`)}} color={'#fff'} bgColor={'#1D2E3D'} height={'3rem'} width={'9rem'}/>
                        </div>
                    </Col>
                </Row>
            }
        </Container>
    );
}

export default OurEvents;